export default "__VITE_ASSET__35555572__"